<template>
    <div class="establishment-move-modal">
        <el-dialog title="Ajouter un établissement" :visible.sync="innerVisible" size="small" :close-on-click-modal="false">
            <ck-form ref='move-establishment' label-position="top">
                <el-row :gutter="12">
                    <el-col :span="24">
                        <div class="ck-form-item">
                            <label class="ck-form-item-label">Rechercher un destinataire</label>
                            <el-autocomplete custom-item="establishment-item" select-when-unmatched style="width: 100%;" v-model="search" :props="autocompleteProps" :fetch-suggestions="querySearch" placeholder="Rechercher un destinataire..." :trigger-on-focus="false" @select="handleSelect">
                            </el-autocomplete>
                        </div>
                    </el-col>
                </el-row>
                <div>
                    <div class="pull-right">
                        <el-button type="default" @click="cancelMove">Annuler</el-button>
                        <el-button type="primary" @click="endMove" native-type="submit">Déplacer</el-button>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </ck-form>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue';

Vue.component('establishment-item', {
    functional: true,
    render: function(h, ctx) {
        var item = ctx.props.item;
        if( item.Value == 'invalid' ) {
            return (<li { ...ctx.data }>
                <span>{item.Label}</span>
            </li>);
        }
        if(item.Extra == 'partner') {
            return (<li { ...ctx.data }>
                <span>{item.Label}</span>
                <span class="label label-important" style="margin-left: 12px;">Partenaire</span>
            </li>);
        }
        
        if(item.Extra == 'managing') {
            return (<li { ...ctx.data }>
                <span>{item.Label}</span>
                <span class="label label-info" style="margin-left: 12px;">Gestionnaire</span>
            </li>);
        }
    },
    props: {
        item: { type: Object, required: true }
    }
});


export default Vue.component('move-establishment-modal', {
    props: {
        establishmentId: Number,
        visible: Boolean,
        isManaging: Boolean
    },
    data() {
        return {
            targetId: 0,
            innerVisible: false,
            search: '',
            autocompleteProps: {
                label: 'Label',
                value: 'Value'
            },
        }
    },
    mounted: function() {
    },
    methods: {
        querySearch(queryString, cb) {
            if (!queryString) cb([]);

            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.$http.get(`/api/establishment/search?search=${queryString}&establishmentId=${this.establishmentId}&isManaging=${this.isManaging}`).then((response) => {
                    if (response.data.length == 0) {
                        cb([{ Label: 'Aucun destinataire trouvé', Value: 'invalid' }]);
                    }
                    else {
                        cb(response.data);
                    }
                });
            }, 200);
        },
        handleSelect(item) {
            if (item.Value == 'invalid') {
                this.targetId = 0;
                return;
            }

            this.targetId = item.Id;
        },
        reset() {
            this.targetId = 0;
            this.search = '';
        },
        cancelMove() {
            this.innerVisible = false;
            this.reset();
        },
        endMove(e) {
            e.preventDefault();
            if (this.targetId != 0) {
                this.$http.post(`/api/establishment/${this.establishmentId}/move/${this.targetId}`).then((response) => {
                    this.$swal({
                        type: 'success',
                        title: 'Déplacé',
                        text: 'L\'établissement a bien été déplacé'
                    }).then(() => {

                    });

                    //reset form
                    this.cancelMove();

                    this.$root.$emit('pcr_update_data');
                    this.$root.$emit('pcr_update_tree');
                });
            }
        }
    },
    watch: {
        innerVisible(val) {
            if(this.visible != val) {
                this.$emit('update:visible', val);
            }
        },
        visible(val) {
            this.innerVisible = val;
            if(!val) {
                this.reset();
            }
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/move-establishment-modal.vue